import { GetSessionQuery as GetSession } from '__generated__/graphql';

import useBaseProject from '../common/useProject';

type Project = GetSession['session']['user']['project_memberships'][0]['project'];

type FeatureFlag = 'preregistrations';

export const useFeatureFlag = (flag: FeatureFlag) => {
  const project = useProject();

  return project.feature_flags.includes(flag);
};

const useProject = () => useBaseProject() as Project;

export default useProject;
